<template>
    <div class="modal-overlay">
        <div class="modal">
            <span  class="delete-icon"
                   @click="$emit('close-modal', true)">
                                <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                            </span>
            <p class="csaMessage">{{message}}</p>
            <div class="d-flex gap-3" v-if="whoPlay !== null">
                <button v-if="whoPlay === 'leader'" class="cancle-btn" @click="confirmHandler('leader')">Team Leader</button>
                <button v-if="whoPlay === 'members'" class="cancle-btn" @click="confirmHandler('members')">Team Members</button>
            </div>
            <div class="d-flex gap-3" v-else>
                <button class="cancle-btn" @click="confirmHandler('leader')">Team Leader</button>
                <button class="cancle-btn" @click="confirmHandler('members')">Team Members</button>
            </div>

        </div>
    </div>
</template>

<script>
    import competition from "../../api-services/competition";

    export default {
        name:'assign-component',
        props: ['confirmUsers', 'confirmTeam', 'confirmTeamLeader' , 'message' , 'training_type' , 'whoPlay'],
        data(){
            return {
                state: false,
                data: null
            }
        },
        mounted(){
            // console.log('assign team leadre '+this.training_type);
            // console.log(this.whoPlay);
        },
        methods:{
            async confirmHandler(type){
                if(this.training_type !== null){
                    const competition_id = this.$route.params.id;
                    await competition.playTraining(type , competition_id);
                    this.$emit('success');
                }else{
                    const competition_id = this.$route.params.id;
                    await competition.playCompetition(type , competition_id);
                    this.$emit('success');
                }

            }
        }

    }
</script>

<style scoped>
    .csaMessage{
        color: var(--text-color-in-confirmation-modal);
    }

    .delete-icon {
        position: absolute;
        top:40.5%;
        right: 31%;
        display: flex;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        border: 1px solid #E95626;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        color: #0e2731;
        background-color: #e95626;
        cursor: pointer;
    }
    .modal-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #021a24cc;
        z-index: 9999;
    }

    .modal {
        text-align: center;
        display: flex !important;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        position: relative !important;
        background-color: var(--background-color-input-create);
        height: 200px;
        border-radius: 20px;
        margin: auto;
        width: 40%;
        
        overflow: visible !important;
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px) {
        .delete-icon{
            top: 36.5%;
        }
    }


    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        font-size: 22px;
        margin: 30px 0;
        color: #FFF;
    }

    button {
        width: 150px;
        height: 50px;
        color: white;
        font-size: 18px;
        border-radius: 8px;
        font-weight: 600;
    }

    .cancle-btn{
        background-color: transparent;
        color: var(--text-color-in-confirmation-modal);
        border: 1px solid var(--text-border-color-in-confirmation-modal);
    }
    /*.cancle-btn:hover{*/
    /*    background-color: #e65c00;*/
    /*    color: #fff;*/
    /*}*/
</style>